<template>
  <div class="headline">
    <h1 class="headline__title">{{ title }}</h1> 

    <span
      v-if="rating"
      class="chip race-rating"
      :style="`background-color: ${ratingColor}; color: ${ratingFontColor};`">
      {{ rating }}
    </span>

    <template v-if="potentialFlip">
      <span
        v-if="potentialFlipDemToGop"
        class="chip flip d-to-r-flip">
        POTENTIAL D &#8594; R FLIP
      </span>

      <span
        v-else
        class="chip flip r-to-d-flip">
        POTENTIAL R &#8594; D FLIP
      </span>
    </template>
  </div>
</template>

<script>
const props = {
  title: {
    default: "Missouri Senate",
    required: true,
    type: String,
  },
  rating: {
    default: "TOSS UP",
    required: true,
    type: String,
  },
  potentialFlip: {
    default: true,
    required: true,
    type: Boolean,
  },
  potentialFlipDemToGop: {
    default: true,
    required: true,
    type: Boolean,
  },
};

const computed = {
  ratingColor() {
    if (this.rating === "TOSS UP") return "#854c79";
    if (this.rating === "SOLID D") return "#4575a1";
    if (this.rating === "LIKELY D") return "#82b7d4";
    if (this.rating === "LEAN D") return "#d1ecf5";
    if (this.rating === "LEAN R") return "#ffcfc6";
    if (this.rating === "LIKELY R") return "#f6887c";
    if (this.rating === "SOLID R") return "#d84b44";

    return "#854c79";
  },
  ratingFontColor() {
    if (this.rating === "TOSS UP" ||
        this.rating === "SOLID D" ||
        this.rating === "SOLID R") return "#fff";

    return "#121212";
  },
};

export default {
  props,
  computed,
};
</script>

<style scoped>
:root {
  --blue: #4575a1;
  --green: #57aea6;
  --purple: #854c79;
  --red: #d84b44;
}

.headline {
  align-items: flex-end;
  border-bottom: 1px solid #fff4;
  display: flex;
  flex-wrap: wrap;
  gap: .5em;
  padding-bottom: .25em;
}

.chip {
  border-radius: 2em;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  min-width: 6em;
  padding: 0 1em;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
}

.d-to-r-flip,
.r-to-d-flip {
  background: linear-gradient(45deg, #4575a1 50%, #d84b44 50%);
}

.r-to-d-flip {
  background: linear-gradient(45deg, #d84b44 50%, #4575a1 50%);
}
</style>
